import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useToken } from './useToken';
import {
    isTokenInitialized,
    getInitializationPromise,
} from '../../util/tokenManager';
import GradientLogo from '../../../public/icons/GradientLogo';

export default function RootRedirect() {
    const [token] = useToken();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const waitForInit = async () => {
            if (!isTokenInitialized() && !token) {
                // Wait for token initialization to complete
                const initPromise = getInitializationPromise();
                if (initPromise) {
                    try {
                        await initPromise;
                    } catch (error) {
                        // Initialization failed, user not logged in
                    }
                }
            }
            setIsLoading(false);
        };

        waitForInit();
    }, [token]);

    // Show loading screen while checking authentication
    if (isLoading && !isTokenInitialized()) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    flexDirection: 'column',
                }}>
                <GradientLogo svgClass={'splash-logo'} />
                <div style={{ marginTop: '20px', fontSize: '18px' }}>Loading...</div>
            </div>
        );
    }

    // Redirect based on authentication status
    if (token) {
        // User is logged in - redirect to private home
        return <Navigate to='/swapandtop' replace />;
    } else {
        // User is logged out - redirect to public posts
        return <Navigate to='/swapandtop/posts' replace />;
    }
}
